<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Jhankar&#39; Lavani Competition Celebrates Folk Culture </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Jhankar&#39; Lavani Competition <span> Celebrates Folk Culture </span></h2>
        </div>
        <div class="row ">
            <div class="col-md-8 g-4 up-event-text">
                <!-- <h4 class="fw-bold">G H Raisoni Memorial District Level singing Competition   </h4> -->
                <h6 class="fw-bold">
                    <strong>Nagpur | April 18</strong>
                </h6>
                <p> <strong>Raisoni Foundation,</strong> in association with <strong>Lokmat Sakhi</strong>, successfully
                    organized the
                    <strong> ‘Jhankar’ Lavani</strong> Competition on <strong>April 18</strong> held at the G H Raisoni
                    College of
                    Engineering auditorium in Hingna, the event was a grand celebration of Maharashtra’s
                    vibrant folk culture, drawing a massive crowd of dance enthusiasts from across Nagpur.
                </p>
                <p>The competition was the culmination of a journey that began with preliminary rounds
                    on April 13. <strong>A total of 28 finalists took to the stage,</strong> delivering high-octane
                    performances that left the audience spellbound.</p>
            </div>
            <div class="col-lg-4 text-end">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-7.webp"
                    alt="play-competition" title="play-competition" class="img-fluid" />
            </div>
        </div>

        <p><strong>Winners</strong> </p>
        <p>The talent was divided into two categories, with the following participants taking home
            the top honors:</p>
        <div class="row row-cols-md-2 row-cols-1 ">
            <div class="col">
                <p><strong>Group A</strong></p>
                <ul class="list-style">
                    <li>First Place -Vaishnavi Sakharkar</li>
                    <li> Second Place- Meghan Dupare</li>
                    <li> Second Place- Priya Meshram</li>
                </ul>
            </div>
            <div class="col">
                <p><strong>Group B</strong></p>
                <ul class="list-style">
                    <li> First Place – Kavita Vaidya
                    </li>
                    <li> Second Place- Manjushri Koltewar
                    </li>
                    <li> Second Place- Seema Bele </li>
                </ul>
            </div>
        </div>
        <p><strong> Consolation Prizes: *</strong></p>
        <ul class="list-style">
            <li> Group A: Ashwini Anturkar, Arpita Vanjari</li>
            <li>
                Group B: Sarita Lwarkar, Snehal Rakhunde</li>
        </ul>
        <hr>
        <h6 class="fw-bold">
            <strong>Event Snapshot</strong>
        </h6>
        <ul class="list-style">
            <li><strong> The Performances:</strong> Dancers performed to iconic Lavani tracks such as
                &#39;Chandra&#39;, &#39;Amhi Nahi Ja&#39;, and &#39;Chadhvila Kamarpatta&#39;, bringing the house down
                with their grace and energy.</li>
            <li> <strong>Expert Judging: </strong>The performances were evaluated by renowned sculptor and
                theatre artist <strong>Chandrakant Chakole</strong> and Bharatanatyam scholar <strong>Shrutika
                    Zade.</strong></li>

            <li> <strong>Dignitaries in Attendance:</strong> The event was graced by <strong>Sachin Untwale
                </strong>(Director,
                G H Raisoni College of Engineering), <strong>Amit Gandhare</strong> (Director, PR Raisoni
                Group), <strong>Manisha Dhomane</strong> (Director, Dhomne Jewellers), and Corporator
                <strong> Suchitra Thakre</strong>.
            </li>
            <li> <strong>Special Thanks: </strong>The event’s success was made possible through the support of
                <strong>Dhomne (Pramod) </strong>Jewellers and the dedicated efforts of the organizing team
                led by <strong>Neha Joshi.</strong>
            </li>
            <p>The evening concluded with a prize distribution ceremony where winners and
                participants were honored for their contribution to preserving and promoting
                traditional folk art.</p>
        </ul>
    </div>
</section>
<section class="section pb-5 fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery h-100">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Play</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1I5EWL46iWcUGsl8H9-wE0USE9KLHHtfp"
                                target="_blank" class="cmn-button">
                                <span> View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <!-- <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-7.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-7.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-7.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-8.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-8.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-8.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-9.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-9.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/zankar-9.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery h-100">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold"> Singing</h4>
                            </div>
                        </div>
                        <!-- <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1J0xRUpXkFiqqCxeBFmR4QF5P3TsCTzCg"
                                target="_blank" class="cmn-button">
                                <span> View More</span>
                            </a>
                        </div> -->
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat-samachar.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat-samachar.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat-samachar.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/lokmat.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/media-lokmat-times.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/media-lokmat-times.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/zankar/media-lokmat-times.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
